import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";

const SINGLE_HEADERS = ["SGST Rate", "CGST Rate", "IGST Rate", "Add CESS"];
const SINGLE_FIELDS = ["SGSTRate", "CGSTRate", "IGSTRate", "AddCESS"];

const MULTIPLE_HEADERS = [
  "SGST Rate", "CGST Rate", "IGST Rate", "Add CESS",
  "BASE RATE", "BASE RATE TO", "BASE RATE INCL", "BASE RATE INCL TO"
];
const MULTIPLE_FIELDS = [
  "SGSTRate", "CGSTRate", "IGSTRate", "AddCESS",
  "BASERate", "BASERateTo", "BaseRateIncl", "BaseRateInclTo"
];

const DEFAULT_ROW = {
  BASERate: "1",
  BASERateTo: "0",
  BaseRateIncl: "0",
  BaseRateInclTo: "0",
  SGSTRate: "0",
  CGSTRate: "0",
  IGSTRate: "0",
  AddCESS: "0",
};

const GstRateTable = ({
  rows = [],
  onRowsChange,
  disabled = false,
  rateSlabType = "Single",
}) => {
  const isMultiple = rateSlabType === "Multiple";
  const headers = isMultiple ? MULTIPLE_HEADERS : SINGLE_HEADERS;
  const fields = isMultiple ? MULTIPLE_FIELDS : SINGLE_FIELDS;

  const [errors, setErrors] = useState({});
  const [initialized, setInitialized] = useState(false);

  // === ALWAYS ENSURE AT LEAST ONE ROW EXISTS ===
  useEffect(() => {
    if (!initialized && rows.length === 0 && !disabled) {
      onRowsChange([DEFAULT_ROW]);
      setInitialized(true);
    }
  }, [rows, onRowsChange, disabled, initialized]);

  // === IF PARENT PASSES EMPTY ARRAY LATER, RESTORE DEFAULT ===
  useEffect(() => {
    if (rows.length === 0 && !disabled) {
      onRowsChange([DEFAULT_ROW]);
    }
  }, [rows, onRowsChange, disabled]);

  // const validateRow = (row, index) => {
  //   const base = Number(row.BASERate) || 0;
  //   const to = Number(row.BASERateTo) || 0;

  //   if (!isMultiple) return "";

  //   if (base < 1) {
  //     return "Base Rate must be ≥ 1";
  //   }
  //   if (to !== 0 && to <= base) {
  //     return `Base Rate To (${to}) must be greater than Base Rate (${base})`;
  //   }
  //   return "";
  // };

  const validateRow = (row) => {
    if (!isMultiple) return "";

    const base = Number(row.BASERate) || 0;
    const to = Number(row.BASERateTo) || 0;

    if (base < 1) {
      return "Base Rate must be ≥ 1";
    }
    if (to === 0) {
      return "Base Rate To cannot be 0";
    }
    if (to <= base) {
      return `Base Rate To (${to}) must be greater than Base Rate (${base})`;
    }
    return "";
  };

  const updateRow = (index, field, value) => {
    const copy = [...rows];
    copy[index][field] = value;

    // Auto-calculate IGST
    if (field === "SGSTRate" || field === "CGSTRate") {
      const sgst = parseFloat(copy[index].SGSTRate) || 0;
      const cgst = parseFloat(copy[index].CGSTRate) || 0;
      copy[index].IGSTRate = (sgst + cgst).toString();
    }

    // === UPDATE NEXT ROW'S BASERATE WHEN BASERATETO CHANGES ===
    if (field === "BASERateTo" && index < copy.length - 1) {
      const currentTo = Number(value) || 0;
      if (currentTo > 0) {
        const nextBaseRate = (currentTo + 1).toString();
        copy[index + 1].BASERate = nextBaseRate;
      }
    }

    // Validate current row
    const error = validateRow(copy[index], index);
    setErrors(prev => ({ ...prev, [index]: error }));

    onRowsChange(copy);
  };

  // ────── ENTER KEY HANDLER ──────

  //   const handleKeyDown = (e, rowIndex) => {
  //   if (e.key !== "Enter") return;
  //   e.preventDefault();

  //   const currentRow = rows[rowIndex];
  //   const error = validateRow(currentRow, rowIndex);
  //   if (error) {
  //     setErrors(prev => ({ ...prev, [rowIndex]: error }));
  //     return;
  //   }

  //   // ── MULTIPLE (existing logic) ──
  //   if (isMultiple) {
  //     const to = Number(currentRow.BASERateTo) || 0;
  //     if (to === 0) {
  //       return;
  //     }
  //     const nextBase = (to + 1).toString();
  //     const empty = Object.fromEntries(
  //       fields.map(f => [
  //         f,
  //         f === "BASERate" ? nextBase :
  //         f === "BaseRateIncl" ? "0" :
  //         f === "BaseRateInclTo" ? "0" : "0"
  //       ])
  //     );
  //     onRowsChange([...rows, empty]);
  //     return;
  //   }

  //   // ── SINGLE → ADD NEW ROW ON ENTER (NEW LOGIC) ──
  //   const emptySingle = {
  //     ...DEFAULT_ROW,
  //     BASERate: "0",
  //     BASERateTo: "0",
  //   };
  //   onRowsChange([...rows, emptySingle]);
  // };

  // Inside GstRateTable.jsx

 const handleKeyDown = (e, rowIndex) => {
  if (e.key !== "Enter") return;
  e.preventDefault();

  const currentRow = rows[rowIndex];
  const error = validateRow(currentRow);

  if (error) {
    toast.error(error, {
      position: "top-center",
      autoClose: 2000,
      style: { marginTop: "300px" },
    });
    return;
  }

  if (!isMultiple) {
    toast.error("Cannot add more than one GST slab rate in Single mode.", {
      position: "top-center",
      autoClose: 1000,
      style: { marginTop: "300px" },
    });
    return;
  }

  const to = Number(currentRow.BASERateTo) || 0;
  if (to === 0) return;

  const nextBase = (to + 1).toString();
  const empty = Object.fromEntries(
    fields.map(f => [
      f,
      f === "BASERate" ? nextBase :
      f === "BaseRateIncl" ? "0" :
      f === "BaseRateInclTo" ? "0" : "0"
    ])
  );
  onRowsChange([...rows, empty]);
};

  //   const isFieldDisabled = (field) => {
  //   return (
  //     disabled ||
  //     (!isMultiple && ["BASERate", "BASERateTo", "BaseRateIncl", "BaseRateInclTo"].includes(field))
  //   );
  // };

  const isFieldDisabled = (field) => {
    // 1. Whole table disabled (read-only mode)
    if (disabled) return true;

    // 2. SINGLE mode → hide & disable all four base-rate fields
    if (!isMultiple) {
      return ["BASERate", "BASERateTo", "BaseRateIncl", "BaseRateInclTo"].includes(field);
    }

    // 3. MULTIPLE mode → ONLY BaseRate, BaseRateIncl, BaseRateInclTo are disabled
    //     → BaseRateTo remains editable
    return ["BASERate", "BaseRateIncl", "BaseRateInclTo"].includes(field);
  };

  // === ALWAYS RENDER AT LEAST ONE ROW ===
  const displayRows = rows.length > 0 ? rows : [DEFAULT_ROW];

  return (
    <Box sx={{ mt: 2, mb: 1, display: 'flex', justifyContent: 'center' }}>
      <TableContainer
        component={Paper}
        elevation={1}
        sx={{
          border: "1px solid #ddd",
          maxHeight: 140,
          overflowY: "auto",
          overflowX: "auto",
          // width: { xs: "60%", sm: "70%", md: "100%" },
          width: { xs: "60%", sm: "80%", md: "100%" }, // Responsive width
          maxWidth: { xs: 500, sm: 700, md: "100%" },
        }}
      >
        <Table size="small" stickyHeader
          sx={{
            minWidth: isMultiple ? 900 : "auto",
            tableLayout: "fixed",
            width: "100%",
          }}
        >
          <TableHead>
            <TableRow>
              {headers.map((h, idx) => {
                const minWidth = isMultiple
                  ? idx < 4
                    ? 50   // SGST, CGST, IGST, CESS
                    : 60  // Base Rate fields
                  : 120;

                return (
                  <TableCell
                    key={h}
                    align="center"
                    sx={{
                      fontWeight: "medium",
                      fontSize: "0.75rem",
                      color: "#1a3d5e",
                      backgroundColor: "#d6e6f2",
                      py: 0.1,
                      px: 0.1,
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      minWidth,      // ← px only
                      width: minWidth,
                      maxWidth: minWidth,
                      boxSizing: "border-box"
                    }}
                  >
                    {h}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {displayRows.map((row, rowIndex) => {
              const isDisabled = isFieldDisabled("");
              const hasError = !!errors[rowIndex] && (rowIndex < rows.length);

              return (
                <TableRow key={rowIndex} hover>
                  {fields.map((field) => {
                    const fieldDisabled = isFieldDisabled(field);
                    const fieldError = hasError && (field === "BASERate" || field === "BASERateTo");

                    return (
                      <TableCell
                        key={field}
                        align="center"
                        sx={{
                          py: 0.1,
                          px: 0.1,
                          position: "relative",
                          boxSizing: "border-box",   // ← Add this
                        }}
                      >
                        <TextField
                          fullWidth
                          size="small"
                          value={row[field] ?? ""}
                          onChange={(e) => updateRow(rowIndex, field, e.target.value)}
                          onKeyDown={(e) => handleKeyDown(e, rowIndex)}
                          disabled={fieldDisabled}
                          variant="outlined"
                          error={fieldError}
                          inputProps={{
                            style: { textAlign: "center", fontSize: "0.8rem" },
                            readOnly: fieldDisabled,
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              height: 28,
                              fontSize: "0.8rem",
                              backgroundColor: fieldDisabled ? "#f5f5f5" : "white",
                            },
                            "& .MuiInputBase-input": {
                              py: 0.3,
                              color: fieldDisabled ? "#666" : "inherit",
                            },
                          }}
                        />
                        {errors[rowIndex] && field === "BASERateTo" && (
                          <Typography
                            variant="caption"
                            color="error"
                            sx={{
                              position: "absolute",
                              bottom: -18,
                              left: 0,
                              right: 0,
                              textAlign: "center",
                              fontSize: "0.65rem",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {errors[rowIndex]}
                          </Typography>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* {errors[displayRows.length - 1] && (
        <Typography color="error" variant="caption" sx={{ mt: 1, display: "block", textAlign: "center" }}>
          {errors[displayRows.length - 1]}
        </Typography>
      )} */}
    </Box>
  );
};

export default GstRateTable;